var _filter, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFilterHandler(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 62,
    viewBox: "0 0 60 62",
    width: 60,
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "IconFilterHandler_svg__a",
    height: "240%",
    width: "261%",
    x: "-80.5%",
    y: "-70%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic",
    stdDeviation: 7
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.993 4A2.99 2.99 0 000 6.99v14.89c0 1.65 1.11 3.745 2.476 4.675L13.414 34l10.245-7.38c1.34-.967 2.428-3.088 2.428-4.74V6.99A2.996 2.996 0 0023.094 4z",
    fill: "#1f2605",
    filter: "url(#IconFilterHandler_svg__a)",
    opacity: 0.09,
    transform: "translate(17 13)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.406 42.39l9.96-7.176c1.211-.873 2.221-2.843 2.221-4.335V15.99c0-1.372-1.12-2.49-2.493-2.49H19.993a2.49 2.49 0 00-2.493 2.49v14.89c0 1.485 1.027 3.424 2.257 4.262z",
    fill: "#fff",
    stroke: "#5e69b1"
  }))));
}

export default SvgIconFilterHandler;